<div class="container">
  <div class="image">
    <img *ngIf="listItem?.awardsCertificate" class="certificate" src="/assets/images/certificate.svg" alt="U ontvangt een certificaat" />
    <img *ngIf="listItem?.headerBase64Image" [src]="listItem?.headerBase64Image" [alt]=""/>
  </div>
  <div class="title">
    <h1>{{listItem?.title}}</h1>
    <span class="body-text">{{ listItem?.summary | stripHtml }}</span>
  </div>
  <div class="cta">
    <app-button (click)="navigateToDetail()">Bekijk {{ getItemTypeAsTring() }}</app-button>
    <a [href]="getSendToUri(listItem?.id, listItem?.title)" class="right-arrow">Stuur door<fa-icon [icon]="faArrowRight"></fa-icon></a>
  </div>
</div>